module.exports = "/_next/static/images/arrow-up-242090d48fbac6b768d08b12dda192af.svg";